<!-- 水果行情 -->
<template>
  <div class="site-content">
    <div class="site-content-page">
      <div class="content-row">
        <div class="content-col col-per-70">
          <infoPageList-05 />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfoPageList05 from '../block/InfoPageList05'
export default {
  name: 'Sghq01',
  components: {
    'infoPageList-05': InfoPageList05
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Sghq01.vue